import { TbArrowsRightLeft } from 'react-icons/tb'
import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import { getIntegrationUrl } from 'routes/Integrations/helpers'
import { INTEGRATION_QUERIES } from 'routes/constants'
import classes from './IntegrationPageOperations.module.scss'

export function IntegrationPageOperations({
  integrationName,
  integrationKey,
  operationsAmount,
}: {
  integrationName: string
  integrationKey: string
  operationsAmount: number
}) {
  return (
    <section className={classes.section}>
      <div className={classes.wrapper}>
        <div className={classes.visual}>
          <div className={classes.box}>
            <TbArrowsRightLeft className={classes.icon} />
          </div>
        </div>

        <div className={classes.content}>
          <Heading as={'h2'} size={'xl'} center>
            Operations
          </Heading>
          <Text size={'lg'} center balance className={classes.subtitle}>
            You can subscribe to changes in data collections when data records
            are created, updated, or deleted. You can also subscribe to{' '}
            {integrationName}-specific operations.
          </Text>
          <Link
            className={classes.link}
            type='secondary'
            href={getIntegrationUrl(
              integrationKey,
              INTEGRATION_QUERIES.OPERATIONS,
            )}
            target='_self'
          >
            Explore {operationsAmount} operations available in {integrationName}
          </Link>
        </div>
      </div>
    </section>
  )
}
